import { useMedia } from 'react-use';

export default function useResponsiveScreen() {
	const isMobile = useMedia(`(max-width: 767px)`);

	return { isMobile };
}
